import { Definition } from "../../../data/Definition";
import { ChartConfigManager } from "../ChartConfigManager";
import {IColorStyle, IFilter, IItem, IMeasure} from "../../../data/Query";

const currentVersion = "2";

type ConfigType = {
    version: string,
    measure: IMeasure[],
    color: IMeasure | null,
    colorScale: IColorStyle | null,
    spatial: IItem | null,
    filters: IFilter[]
};

export class ScatterChartConfigManager extends ChartConfigManager {
    private definition: Definition;

    constructor(definition: Definition) {
        super();

        this.definition = definition;
    }

    currentVersion(): string {
        return currentVersion;
    }

    isCurrentVersion(config: any): boolean {
        return config !== null && config.version !== undefined && config.version === currentVersion;
    }

    validate(config: any): boolean {
        return this.isCurrentVersion(config) && config.measure && config.measure.length >= 2;
    }

    convert(config: any): any {
        return this.isCurrentVersion(config) ? config : this.convertToCurrent(config);
    }

    convertToCurrent(config: any) {
        if(!config) {
            let newConfig = {} as ConfigType;
            newConfig.version = currentVersion;
            return newConfig;
        }

        return this.convertFromV1(config);
    }

    convertFromV1(config: any): ConfigType {
        let newConfig = {} as ConfigType;
        newConfig.version = currentVersion;

        console.log('convertFromV1', config);

        if(config == null) {
            return newConfig;
        }

        // measures items
        if(config.measure && config.measure.length === 3) {
            newConfig.measure = config.measure.map((m: any) => {
                return {
                    source: {
                        item: m.item,
                        sub: m.value
                    }
                };
            });
        }

        // color item
        if(config.color) {
            newConfig.color = {
                source: {
                    item: config.color.item,
                    sub: config.color.value
                }
            };
        }

        // spatial entity item
        if(config.spatial.item) {
            newConfig.spatial = {
                item: config.spatial.item,
                sub: null
            }
        }

        // filters definitions
        if(config.filters) {
            newConfig.filters = config.filters.map((filter: any): IFilter => {
                return {
                    source: {
                        item: filter.item,
                        sub: null
                    },
                    operation: filter.operation,
                    value: filter.value
                };
            });
        }

        // colorscale
        if(config.colorScale) {
            newConfig.colorScale = {
                scale: config.colorScale,
                color: null
            }
        }

        return newConfig;
    }
}
